export enum UserPermission {
    VIEW_USER_SESSION_HISTORY = 'VIEW_USER_SESSION_HISTORY',
    WITHDRAW_FROM_SYSTEM_ACCOUNT = 'WITHDRAW_FROM_SYSTEM_ACCOUNT',
    BLOCK_TRADERS = 'BLOCK_TRADERS',
    UNBLOCK_TRADERS = 'UNBLOCK_TRADERS',
    CREATE_ADMINS = 'CREATE_ADMINS',
    EDIT_PERMISSIONS = 'EDIT_PERMISSIONS',
    EDIT_SETTINGS = 'EDIT_SETTINGS',
    EDIT_SETTINGS_PAYMENT_PAGE = 'EDIT_SETTINGS_PAYMENT_PAGE',
    EDIT_MANUAL_PRIORITIES = 'EDIT_MANUAL_PRIORITIES',
    PROCESS_WITHDRAWAL = 'PROCESS_WITHDRAWAL',
    INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
    REDIRECT_PAYOUTS = 'REDIRECT_PAYOUTS',
    BALANCE_CORRECTION = 'BALANCE_CORRECTION',
    HIDE_DEAL_RATES = 'HIDE_DEAL_RATES',
    HIDE_ROUTING_SECTION = 'HIDE_ROUTING_SECTION',
    HIDE_STATISTICS_SECTION = 'HIDE_STATISTICS_SECTION',
    HIDE_STATISTICS_SUMMARY = 'HIDE_STATISTICS_SUMMARY',
    RESEND_COMPLETED_DEAL_WEBHOOK = 'RESEND_COMPLETED_DEAL_WEBHOOK',
    MERCHANT_WITHDRAW_CREATE = 'MERCHANT_WITHDRAW_CREATE',
    PAYMENTS_TRADER_SETTLEMENTS = 'PAYMENTS_TRADER_SETTLEMENTS',
    PAYMENTS_CLIENT_SETTLEMENTS = 'PAYMENTS_CLIENT_SETTLEMENTS',
    ACCEPT_AML_REJECTED_DEPOSITS = 'ACCEPT_AML_REJECTED_DEPOSITS',
    DISABLE_USER_2FA = 'DISABLE_USER_2FA',
    RESET_TRADER_PASSWORD = 'RESET_TRADER_PASSWORD',
    RESET_MERCHANT_PASSWORD = 'RESET_MERCHANT_PASSWORD',
    RESET_OPERATOR_PASSWORD = 'RESET_OPERATOR_PASSWORD',
    RESET_ADMIN_PASSWORD = 'RESET_ADMIN_PASSWORD',
    MANAGE_TRADER_TRAFFIC = 'MANAGE_TRADER_TRAFFIC',
    DASHBOARD_PLUS = 'DASHBOARD_PLUS',
    DISPUTE_COMPLETED_PAY_IN_DEALS = 'DISPUTE_COMPLETED_PAY_IN_DEALS',
    EDIT_TRADER_RATES_BULK = 'EDIT_TRADER_RATES_BULK'
}
